import {ScheduleTrain, TrainTimetableEntry} from './train';
import {KonegisCauseCode} from './konegis-cause-code';

export interface Station {
  passengerTraffic: boolean;
  type: string;
  stationName: string;
  stationShortCode: string;
  stationUICCode: number;
  countryCode: string;
  longitude: number;
  latitude: number;
}

export class StationTrainRow {
  train: ScheduleTrain;
  arrival: TrainTimetableEntry;
  departure: TrainTimetableEntry;
  commercial: boolean;
  stop: boolean;
  cancelled: boolean;
  track: string;
  causes: KonegisCauseCode;

  constructor() {
  }
}
